import _ from "lodash";

export default function getLocale() {
  let locale = window.location.hash.split("/")[1];
  const available_locales =
    process.env.REACT_APP_AVAILABLE_LOCALES.split("|") || [];
  if (_.isEmpty(locale) || available_locales.indexOf(locale) === -1) {
    locale = process.env.REACT_APP_DEFAULT_LOCALE;
  }
  return locale;
}



// WEBPACK FOOTER //
// ./src/helpers/getLocale.js